import React, { useEffect, useState, useContext} from 'react';
import scheme from '../../static/js/scheme';
import vm from '../../static/js/unit';
import ChangeTabContext from '../comps/CreateContext';
import {imgCrop} from '../../static/js/imgcrop';
import Base from '../../base';
import * as h5share from '@auto/h5share';
import './header.scss';

const Header = ({sID}) => {

  const [header, setHeader] = useState({});
  const [vr, setVr] = useState('');
  const [load, setLoad] = useState(0);
  const URLs = {
    series_pc: `https://www.autohome.com.cn/${sID}/`,
    series_m: `https://m.autohome.com.cn/${sID}/`,
    series_app: `autohome://car/seriesmain?seriesid=${sID}`,
    img_pc: `https://car.autohome.com.cn/chezhan/exps${process.env.REACT_APP_CHEZHAN_ID}/${sID}.html`,
    // img_pc: `https://car.autohome.com.cn/pic/series/${sID}-55.html`, // TODO
    img_m: `https://car.m.autohome.com.cn/pic/series/${sID}-0-55-0-i0.html`,
    img_app: `autohome://car/seriespicture?seriesid=${sID}&orgin=0&categoryid=55`,
    config_pc: `https://car.autohome.com.cn/config/series/${sID}.html`,
    config_m: `https://car.m.autohome.com.cn/config/series/${sID}.html`,
    config_app: `autohome://carcompare/paramcontrast?seriesid=${sID}&seriesname=${header && header.seriesname ? header.seriesname : ''}`,
    ask_pc: `https://dealer.autohome.com.cn/dealer/order-${sID}.html?siteid=835&pvareaid=6848649`,
    ask_m: `https://dealer.m.autohome.com.cn/dealer/order-${sID}.html?siteid=835&pvareaid=6848648`,
    ask_app: `https://dealer.m.autohome.com.cn/dealer/order-${sID}.html?siteid=835&pvareaid=6848647`,
  };

  const {
    mainId,
    brandName,
    setBrandName,
  } = useContext(ChangeTabContext);
  
  useEffect(() => {
    vm.ajax({
      url: process.env.REACT_APP_CHENGDU + 'seriesInfoById',
      data: {
        showid: process.env.REACT_APP_CHEZHAN_ID,
        seriesid: sID,
      },
      success(res) {
        setHeader(res.result);
        if (brandName === '') setBrandName(res.result.brandname);
        const url = Base.href.replace(mainId, sID);
        const img = imgCrop(res.result.serieslogo, '300x0_0_q80_c40__');
        if (scheme.version) {
          window.AHAPP.setNativeShareInfo({
            platform: 'all',
            url: url,
            title: Base.shareTitle,
            content: Base.shareContent,
            imgurl: res.result.serieslogo, // 不能使用切图，安卓会报分享失败
          });
        }
        h5share.setData({
          dest: 'all', // all, wechat, pyq, qq, qzone, weibo
          url: url,
          title: Base.shareTitle,
          desc: Base.shareContent,
          imgUrl: img,
        });
      },
    });
    vm.ajax({
      url: process.env.REACT_APP_PANO + '/v1/vr/getcarvrinfobyseriesid',
      data: {
        _appid: 'car',
        category: 'car',
        seriesid: sID,
      },
      success: (data) => {
        if (data.Result.IntInfo.length > 0 && data.Result.IntInfo[0].ShowUrl) {
          data.Result.IntInfo.every((item) => {
            if (item.is_show) {
              const link = Base.source === 'app' ? `autohome://insidebrowserwk?url=${encodeURIComponent(item.ShowUrl)}&_ahrotate=2&navigationbarstyle=2` : item.ShowUrl;
              setVr(link);
              return false;
            }
            return true;
          });
        }
      },
    });
  }, []);

  const handleClick = (name) => {
    Base.tongji('carlist', {
      name: name,
      series: sID,
    });
  };

  return (
    header.seriesname !== '' && <header className="header">
      <a className="header__img" style={{opacity: load}} href={scheme.insidebrowser(URLs['img_' + Base.source])}><img onLoad={() => setLoad(1)} src={imgCrop(header.serieslogo, '720x0_0_q80_c42__')} alt="" /></a>
      <h1 className="header__title" title={header.newcarintomarket === 1 ? '新车上市' : header.firstpublish === 1 ? '新车首发' : ''}>{header.seriesname}</h1>
      <div className="header-btn__box">
        <a onClick={() => handleClick('车系页')} href={scheme.insidebrowser(URLs['series_' + Base.source])}><i className="icon-series"></i>车系</a>
        <a onClick={() => handleClick('图片')} href={scheme.insidebrowser(URLs['img_' + Base.source])}><i className="icon-pic"></i>图片</a>
        {vr && <a onClick={() => handleClick('vr')} href={vr}><i className="icon-vr"></i>VR</a>}
        <a onClick={() => handleClick('参配')} href={scheme.insidebrowser(URLs['config_' + Base.source])}><i className="icon-config"></i>参配</a>
      </div>
    </header>
  )
}

export default Header;